import HomePage from 'src/components/views/Home';
import LoginPage from 'src/components/views/Login/LoginPage';
import ResetPage from 'src/components/views/Login/ResetPage';
// import OrderMedicineListPage from 'src/components/views/Order/OrderMedicineListPage';
// import OrderPrescriptionListPage from 'src/components/views/Order/OrderPrescriptionListPage';
import OrderListPage from 'src/containers/OrderList';
import DoctorAuditListPage from 'src/containers/DoctorAuditList';
import DoctorDetailPage from 'src/containers/DoctorDetail';
import DoctorListPage from 'src/containers/DoctorList';
import DoctorBatchModifyPage from 'src/containers/DoctorBatchModify';
import DrugStoreAddPage from 'src/containers/DrugStoreAdd';
import DrugStoreListPage from 'src/containers/DrugStoreList';
import OrderDetailPage from 'src/containers/OrderDetail';
import PaymentSetPage from 'src/containers/PaymentSet';
import UserAdminListPage from 'src/containers/UserAdminList';
import UserAdminEditPage from 'src/containers/UserAdminEdit';
import WalletPage from 'src/containers/Wallet';
import WalletRegisterPage from 'src/containers/WalletRegister';
import WalletDetailPage from 'src/containers/WalletDetail';
import WalletBindCardPage from 'src/containers/WalletBindCard';
import PriceChangeRecordPage from './views/Price/PriceChangeRecordListPage';
import PriceChangeDetailPage from 'src/containers/PriceChangeDetail';
import MallPharmacyListPage from 'src/containers/MallPharmacyList';
import MallPharmacyAddPage from 'src/containers/MallPharmacyAdd';
import MallPharmacyDetailPage from 'src/containers/MallPharmacyDetail';
import MallMedicineListPage from 'src/containers/MallMedicineList';
import DepartmentAdminListPage from 'src/containers/DepartmentAdminList';
import DepartmentAdminDetailPage from 'src/containers/DepartmentAdminDetail';
import PromotionListPage from 'src/containers/PromotionList';
import BookKeepingListPage from 'src/containers/BookKeepingList';

export interface IComponentOrPage {
  [key: string]: any;
  LoginPage: React.ComponentClass;
  ResetPage: React.ComponentClass;
  HomePage: any;
  DoctorAuditListPage: any;
  DoctorDetailPage: any;
  DoctorListPage: any;
  DoctorBatchModifyPage: any;
  DrugStoreAddPage: any;
  DrugStoreListPage: any;
  OrderListPage: any;
  OrderDetailPage: any;
  PaymentSetPage: any;
  UserAdminListPage: any;
  UserAdminEditPage: any;
  WalletPage: React.ComponentClass;
  WalletRegisterPage: React.ComponentClass;
  WalletDetailPage: React.ComponentClass;
  WalletBindCardPage: React.ComponentClass;
  MallPharmacyListPage: React.ComponentClass;
  MallPharmacyAddPage: React.ComponentClass;
  MallPharmacyDetailPage: React.ComponentClass;
  MallMedicineListPage: React.ComponentClass;
  DepartmentAdminListPage: React.ComponentClass;
  DepartmentAdminDetailPage: React.ComponentClass;
  PromotionListPage: React.ComponentClass;
  BookKeepingListPage: React.ComponentClass;
}

export const AllComponents: IComponentOrPage = {
  LoginPage,
  ResetPage,
  HomePage,
  DoctorAuditListPage,
  DoctorDetailPage,
  DoctorListPage,
  DoctorBatchModifyPage,
  DrugStoreAddPage,
  DrugStoreListPage,
  PriceChangeRecordPage,
  PriceChangeDetailPage,
  OrderListPage,
  OrderDetailPage,
  PaymentSetPage,
  UserAdminListPage,
  UserAdminEditPage,
  WalletPage,
  WalletRegisterPage,
  WalletDetailPage,
  WalletBindCardPage,
  MallPharmacyListPage,
  MallPharmacyAddPage,
  MallPharmacyDetailPage,
  MallMedicineListPage,
  DepartmentAdminListPage,
  DepartmentAdminDetailPage,
  PromotionListPage,
  BookKeepingListPage,
};

// export {
//     LoginPage, ResetPage, HomePage,
//     DoctorAuditListPage, DoctorDetailPage, DoctorListPage,
//     DrugStoreAddPage, DrugStoreListPage, MedicineEditPage,
//     MedicineListPage, PriceListPage, OrderListPage,
//     OrderDetailPage, PaymentSetPage, };



// WEBPACK FOOTER //
// ./src/components/index.tsx